import React, { useState, useEffect, useRef } from "react";
import { Modal, message, Button, Table, Pagination } from "antd";
import { Col, Row } from "react-bootstrap";
import { API, Headers } from "../../Config";
import axios from "axios";
import moment from "moment";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import "./style.css";
// import Companyseal from "../../Assets/Images/seal.JPG";
import Companyseal from "../../Assets/Images/sahari-seal.png";
import { POST } from "../../Config/ApiRequests";

function PrintCustomesModal(props) {
  const componentRef = useRef();
  const [loading, setLoading] = useState(true);
  const [boxItems, setBoxItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [USD, setUsd] = useState(0);
  const [exchangeData, setexchangeData] = useState([]);

  const [isLoading2, setIsLoading2] = useState(false);
  const [exchangeRates, setexchangeRates] = useState([]);
  const [meta, setMeta] = useState({});
  const [selectedRate, setSelectedRate] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  console.log("props?.item --- ", props?.item);

  useEffect(() => {
    loadDetails();
  }, []);

  useEffect(() => {
    getExchangeRates(1, 10);
  }, []);

  const getExchangeRates = async (_page, _take) => {
    try {
      setIsLoading2(true);
      let api = API.EXCHANGE_RATE_LIST;
      let obj = {
        page: _page,
        take: _take,
      };
      const excData = await POST(api, obj);
      if (excData?.status) {
        setexchangeRates(excData?.data);
        setSelectedRate(excData?.data[0]);
        setUsd(excData?.data[0]?.sar_usd);
        setMeta(excData?.meta);
        setIsLoading2(false);
      } else {
        message.error("No data found");
        setIsLoading2(false);
      }
    } catch (err) {
      message.error("Oops.Something went");
      setIsLoading2(false);
    }
  };

  const loadDetails = () => {
    setBoxItems(props.item.boxe_item);
  };

  // const GetCurrancy = async () => {
  //   const URL = API.BASR_URL + API.EXCHANGE_RATE + "SAR_USD";
  //   try {
  //     const response = await axios.get(URL, {});
  //     if (response?.status) {
  //       const data = response?.data?.data?.rate;
  //       setexchangeData(data);
  //       setUsd(data);
  //       return Number(data);
  //     } else {
  //       setIsLoading(false);
  //       message.error("Oops.Something went");
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return null;
  //   }
  // };

  // const calculateItemsPerPage = (totalItems) => {
  //   // Optimized to fit 70 items on first page with fixed signature/seal
  //   if (totalItems <= 70) {
  //     return totalItems;
  //   } else if (totalItems <= 90) {
  //     return 70;
  //   } else if (totalItems <= 110) {
  //     return 80;
  //   } else {
  //     return 90;
  //   }
  // };

  // const splitItemsIntoPages = (items) => {
  //   const totalItems = items.length;

  //   if (totalItems <= 70) {
  //     return {
  //       firstPageItems: items,
  //       remainingItems: [],
  //       hasMultiplePages: false,
  //     };
  //   }

  //   const itemsPerFirstPage = calculateItemsPerPage(totalItems);
  //   const firstPageItems = items.slice(0, itemsPerFirstPage);
  //   const remainingItems = items.slice(itemsPerFirstPage);

  //   return {
  //     firstPageItems,
  //     remainingItems,
  //     hasMultiplePages: remainingItems.length > 0,
  //   };
  // };

  const renderItemsTable = (
    items,
    startIndex = 0,
    isFirstPage = true,
    basicValue = 0,
    frieghtValue = 0,
    InsuranceValue = 0,
    totalValue = 0
  ) => {
    // Sort items: numerically if item is a number, alphabetically otherwise
    const sortedItems = [...items].sort((a, b) => {
      const itemA = a.item.toString().trim();
      const itemB = b.item.toString().trim();

      // Check if both items are numeric
      const isNumericA = !isNaN(parseFloat(itemA)) && isFinite(itemA);
      const isNumericB = !isNaN(parseFloat(itemB)) && isFinite(itemB);

      if (isNumericA && isNumericB) {
        // Sort numerically
        return parseFloat(itemA) - parseFloat(itemB);
      } else {
        // Sort alphabetically (case-insensitive)
        return itemA.localeCompare(itemB, undefined, { sensitivity: "base" });
      }
    });

    const totalItems = sortedItems.length;
    const itemsPerColumn = Math.ceil(totalItems / 3);

    return (
      <table
        className="print-invoice-table"
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <tr>
          <td colSpan={3} style={{ border: "none", padding: "0" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "2px",
                margin: "0",
                padding: "0",
              }}
            >
              {/* First Column */}
              <table
                className="print-invoice-table"
                style={{
                  width: "32%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                  borderCollapse: "collapse",
                }}
              >
                <tr>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "15%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Qty
                    </div>
                  </th>
                </tr>
                {sortedItems.slice(0, itemsPerColumn).map((item, index) => (
                  <tr key={item.id || index}>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        fontSize: "8px",
                        verticalAlign: "top",
                        width: "65%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ lineHeight: "1.1", margin: "0" }}
                      >
                        {startIndex + index + 1}. {item.item}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                        width: "15%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {item.quantity}
                      </div>
                    </td>
                  </tr>
                ))}
              </table>

              {/* Second Column */}
              <table
                className="print-invoice-table"
                style={{
                  width: "32%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                  borderCollapse: "collapse",
                }}
              >
                <tr>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "15%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Qty
                    </div>
                  </th>
                </tr>
                {sortedItems
                  .slice(itemsPerColumn, itemsPerColumn * 2)
                  .map((item, index) => (
                    <tr key={item.id || index + itemsPerColumn}>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          padding: "2px",
                          fontSize: "8px",
                          verticalAlign: "top",
                          width: "65%",
                          height: "14px",
                        }}
                      >
                        <div
                          className="print-customer-invoice-pdf-txt"
                          style={{ lineHeight: "1.1", margin: "0" }}
                        >
                          {startIndex + index + itemsPerColumn + 1}. {item.item}
                        </div>
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          padding: "2px",
                          textAlign: "center",
                          fontSize: "8px",
                          width: "15%",
                          height: "14px",
                        }}
                      >
                        <div
                          className="print-customer-invoice-pdf-txt"
                          style={{ margin: "0" }}
                        >
                          {item.quantity}
                        </div>
                      </td>
                    </tr>
                  ))}
              </table>

              {/* Third Column */}
              <table
                className="print-invoice-table"
                style={{
                  width: "32%",
                  margin: "0",
                  padding: "0",
                  borderSpacing: "0",
                  borderCollapse: "collapse",
                }}
              >
                <tr>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Description
                    </div>
                  </th>
                  <th
                    style={{
                      border: "1px solid #bfbfbf",
                      padding: "3px",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      width: "15%",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "9px",
                        lineHeight: "1.1",
                        fontWeight: "bold",
                      }}
                    >
                      Qty
                    </div>
                  </th>
                </tr>
                {sortedItems.slice(itemsPerColumn * 2).map((item, index) => (
                  <tr key={item.id || index + itemsPerColumn * 2}>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        fontSize: "8px",
                        verticalAlign: "top",
                        width: "65%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ lineHeight: "1.1", margin: "0" }}
                      >
                        {startIndex + index + itemsPerColumn * 2 + 1}.{" "}
                        {item.item}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                        width: "15%",
                        height: "14px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {item.quantity}
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </td>
        </tr>
        {/* {isFirstPage && (
          <tr>
            <td colSpan={3} style={{ padding: "5px 0" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid #bfbfbf",
                }}
              >
                <tr>
                  <td
                    style={{
                      border: "1px solid #bfbfbf",
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "9px",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{ margin: "0", fontWeight: "bold" }}
                    >
                      Basic Value: {basicValue}
                    </div>
                  </td>

                  <td
                    style={{
                      border: "1px solid #bfbfbf",
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "9px",
                    }}
                  >
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{ margin: "0", fontWeight: "bold" }}
                    >
                      Total Value: ${basicValue}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        )} */}
      </table>
    );
  };

  const medianBoxNum = Math.floor(boxItems.length / 2);

  let requestData = {
    is_for_customer: true,
  };
  const isPrinted = () => {
    axios({
      method: "put",
      url:
        API.BASR_URL +
        API.BOXES_ACTIONS +
        "print/" +
        props.item.box_number +
        "/is_for_customer",
      headers: Headers(),
      data: requestData,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onClose();
          props.reload();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };
  const [showExcel, setShowExcel] = useState(false);

  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);

  let basicValue = Number(
    props?.item?.boxe_item?.reduce(function (tot, arr) {
      return (
        Number(tot) +
        Number(arr?.value * arr?.quantity * Number(selectedRate?.sar_usd))
      );
    }, 0)
  ).toFixed(2);

  let frieghtValue = Number(basicValue * 0.2).toFixed(2);
  let InsuranceValue = Number(basicValue * 0.01125).toFixed(2);

  let totalValue = Number(
    Number(basicValue) + Number(frieghtValue) + Number(InsuranceValue)
  ).toFixed(2);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text) => <a>{moment(text).format("ll")}</a>,
    },
    {
      title: "To Date",
      dataIndex: "to_date",
      key: "to_date",
      render: (text) => <a>{moment(text).format("ll")}</a>,
    },
    {
      title: "SAR - USD",
      dataIndex: "sar_usd",
      key: "sar_usd",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "SAR - INR",
      dataIndex: "sar_inr",
      key: "sar_inr",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "INR - SAR",
      dataIndex: "inr_sar",
      key: "inr_sar",
      render: (text) => <a>{text}</a>,
    },
  ];

  return (
    <Modal
      visible={props.visible}
      onOk={() => props.onClose()}
      onCancel={() => props.onClose()}
      width={900}
      footer={null}
    >
      <div ref={componentRef}>
        <div className="print-invoice-page">
          <table className="print-invoice-table">
            {/* ------------------- new change ------------------- */}

            <tr>
              <td
                colSpan={2}
                style={{
                  padding: "8px",
                  verticalAlign: "top",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "15px",
                    lineHeight: "1.2",
                    margin: "0",
                    fontWeight: "bold",
                  }}
                >
                  <div>SAHARI INTERNATIONAL</div>
                  <div>COURIER SERVICES</div>
                </div>
              </td>
              <td
                colSpan={5}
                style={{
                  padding: "8px",
                  textAlign: "right",
                  verticalAlign: "top",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "13px",
                    marginBottom: "3px",
                    textAlign: "right",
                    margin: "0",
                    fontWeight: "bold",
                  }}
                >
                  AIRWAY BILL NO
                </div>
                <div style={{ textAlign: "right" }}>
                  <Barcode
                    value={props?.item?.box_number}
                    height="35"
                    font="Montserrat-Regular"
                    fontSize={11}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={7}>
                <table
                  style={{
                    width: "100%",
                    fontSize: "9px",
                    borderCollapse: "collapse",
                    marginBottom: "5px",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        DATE
                      </div>
                    </th>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        ORIGIN
                      </div>
                    </th>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        DESTINATION
                      </div>
                    </th>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        REFERENCE NO
                      </div>
                    </th>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        PIECES
                      </div>
                    </th>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        WEIGHT
                      </div>
                    </th>
                    <th
                      style={{
                        width: "14.28%",
                        textAlign: "center",
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        backgroundColor: "#f5f5f5",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        INVOICE VALUE
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {moment(props?.item?.createdAt).format("DD-MM-YYYY")}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        SAUDI ARABIA
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {props?.item?.country?.length > 2
                          ? props?.item?.country
                          : props?.item?.collection &&
                            props?.item?.collection?.recivercountries &&
                            props?.item?.collection?.recivercountries?.name}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {props?.item?.box_ref_no
                          ? props?.item?.box_ref_no
                          : props?.item?.referance_details
                          ? props?.item?.referance_details
                          : ""}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        1
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        {props?.item?.chargable_weight}
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid #bfbfbf",
                        padding: "2px",
                        textAlign: "center",
                        fontSize: "8px",
                      }}
                    >
                      <div
                        className="print-customer-invoice-pdf-txt"
                        style={{ margin: "0" }}
                      >
                        ${props?.item?.total_value_usd}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td
                colSpan={3}
                style={{
                  padding: "5px",
                  verticalAlign: "top",
                  border: "1px solid #bfbfbf",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "10px",
                    marginBottom: "2px",
                    margin: "0",
                  }}
                >
                  DECLARATION
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.5",
                    margin: "0",
                  }}
                >
                  Shipper certifies that the nature of goods is as AIRWAY BILL
                  the shipper agree to and accept the contract conditions on the
                  reverse side here of and acknowledges that the goods described
                  herein is accepted by SAHARI INTERNATIONAL COURIER SERVICE for
                  clearance to said contract condition. shipper declares that
                  goods carried under this consignmet contain no DANGEROUS
                  GOODS, as described under the IATA dangerous goods regulation.
                </div>
              </td>
              <td
                colSpan={4}
                style={{
                  padding: "5px",
                  verticalAlign: "top",
                  border: "1px solid #bfbfbf",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.5",
                    margin: "0",
                  }}
                >
                  I{" "}
                  <b style={{ textTransform: "uppercase" }}>
                    {props?.item?.iqama_name}
                  </b>{" "}
                  ID:{" "}
                  <b style={{ textTransform: "uppercase" }}>
                    {props?.item?.iqama_number}
                  </b>{" "}
                  holder of Indian Passport No/Aadhaar No:- Do here by appointed
                  SAHARI INTERNAIONAL COURIER SERVICES as my authorised agent to
                  do the courier clearance in india for me and sending to{" "}
                  <b style={{ textTransform: "uppercase" }}>
                    {props?.item?.adhar_name}
                  </b>{" "}
                  as a gift consignment
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={7}>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "13px",
                    textAlign: "center",
                    margin: "4px 0",
                    padding: "5px",
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  INVOICE/PACKING LIST
                </div>
              </td>
            </tr>
            <tr>
              <td
                colSpan={3}
                style={{
                  padding: "5px",
                  verticalAlign: "top",
                  border: "1px solid #bfbfbf",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "10px",
                    marginBottom: "4px",
                    margin: "0",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Sender Name & Address
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.iqama_name} ID: {props?.item?.iqama_number}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.1",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.address}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "8px",
                    margin: "0",
                  }}
                >
                  {props?.item?.sender_mobile}
                </div>

                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "12px",
                    marginBottom: "2px",
                    margin: "0",
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  Consignee Name & Address
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.adhar_name}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.adhar_address}, {props?.item?.pin}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.district}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.state}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    marginBottom: "1px",
                    margin: "0",
                  }}
                >
                  {props?.item?.country?.length > 2
                    ? props?.item?.country
                    : props?.item?.collection &&
                      props?.item?.collection?.recivercountries &&
                      props?.item?.collection?.recivercountries?.name}
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "8px",
                    lineHeight: "1.3",
                    margin: "0",
                  }}
                >
                  {props?.item?.reciver_mobile1}
                </div>
              </td>
              <td
                colSpan={4}
                style={{
                  padding: "5px",
                  verticalAlign: "top",
                  border: "1px solid #bfbfbf",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "10px",
                    marginBottom: "4px",
                    textAlign: "center",
                    margin: "0",
                    borderBottom: "1px solid grey",
                  }}
                >
                  Gifts For Personal Use Only
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginRight: "5px",
                      backgroundColor: "#f0f0f0",
                      padding: "2px",
                      borderRadius: "2px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      P
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      O
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      D
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "8px",
                        lineHeight: "1.5",
                        marginBottom: "2px",
                        margin: "0",
                      }}
                    >
                      I, the undersigned on behalf of the above sender/shipper
                      acknowledgement the receipt of goods in good condition
                    </div>
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "8px",
                        lineHeight: "1.1",
                        marginBottom: "5px",
                        color: "#000",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      <b>Receiver Name:</b> {props?.item?.adhar_name}
                    </div>
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "8px",
                        lineHeight: "1.3",
                        marginBottom: "5px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      <b>Date:</b>
                    </div>
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "8px",
                        lineHeight: "1.3",
                        marginBottom: "5px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      <b>Time:</b>
                    </div>
                    <div
                      className="print-customer-invoice-pdf-txt"
                      style={{
                        fontSize: "8px",
                        lineHeight: "1.3",
                        margin: "0",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      <b>Signature:</b>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            {/* Items Table - FLEXIBLE HEIGHT */}
            <tr style={{ flex: "1" }}>
              <td colSpan={7} style={{ verticalAlign: "top" }}>
                {renderItemsTable(
                  props?.item?.boxe_item,
                  0,
                  true,
                  basicValue,
                  frieghtValue,
                  InsuranceValue,
                  totalValue
                )}
              </td>
            </tr>
            {/* Terms and Conditions Section */}
            <tr>
              <td colSpan={7}>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    margin: "2px 0",
                    fontSize: "8px",
                    lineHeight: "1.4",
                  }}
                >
                  1. I.Mr/Mrs{" "}
                  <b style={{ textTransform: "uppercase" }}>
                    {props?.item?.iqama_name}
                  </b>{" "}
                  ID:
                  <b style={{ textTransform: "uppercase" }}>
                    {props?.item?.iqama_number}
                  </b>{" "}
                  for my family/friends, personal use as gift.not for sale.
                  Shipper also declare that he is liable of any customs
                  duty/fine / penalites against this shipment at origin and
                  destination
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    margin: "2px 0",
                    fontSize: "8px",
                    lineHeight: "1.4",
                  }}
                >
                  2. Shipper certifies that the particulars on the face here of
                  are correct and that insofar as any part of the consignemt
                  contains Dangerous Goods if any surch part is property by name
                  and is in proper condition for carriage by air according to
                  the Internation Transport Association's applicable dangerous
                  goods regulations and civil Aviation Regulation of the United
                  Arab Emirates.
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    margin: "2px 0",
                    fontSize: "8px",
                    lineHeight: "1.4",
                  }}
                >
                  3. I/We agree that standard terms and conditions apply for
                  this shipment and liability to terms and conditions. Warsaw
                  Convention amy apply. I/We Service Liability shall not exceed
                  $100.00 for any shipment.
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    margin: "2px 0",
                    fontSize: "8px",
                    lineHeight: "1.4",
                  }}
                >
                  4. The Shipper also here by authorize forward the shipment in
                  full or part their convenience
                </div>
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    margin: "2px 0",
                    fontSize: "8px",
                    lineHeight: "1.4",
                  }}
                >
                  5. The Shipper also here by authorize and their Counterpart
                  India to clear the parcel on behalf of me and same should be
                  delivered to the Consignee address.
                </div>
              </td>
            </tr>
            <tr>
              <td
                colSpan={3}
                style={{
                  height: "90px",
                  verticalAlign: "top",
                  padding: "8px",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    fontSize: "11px",
                    marginBottom: "8px",
                    fontWeight: "bold",
                  }}
                >
                  Customer Signature
                </div>
                {props?.item?.signature ? (
                  <div style={{ display: "block", marginTop: "5px" }}>
                    <img
                      src={props?.item?.signature}
                      height="60px"
                      width="60px"
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      height: "60px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "9px",
                      color: "#999",
                    }}
                  ></div>
                )}
              </td>
              <td
                colSpan={4}
                style={{
                  height: "90px",
                  verticalAlign: "top",
                  textAlign: "right",
                  padding: "8px",
                }}
              >
                <div
                  className="print-customer-invoice-pdf-txt"
                  style={{
                    textAlign: "right",
                    marginBottom: "8px",
                    fontSize: "11px",
                    fontWeight: "bold",
                  }}
                >
                  Company SEAL
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "8px",
                    height: "60px",
                  }}
                >
                  <img
                    src={Companyseal}
                    height="60px"
                    width="60px"
                    style={{
                      display: "block",
                    }}
                  />
                  {props?.item?.collection &&
                  props?.item?.collection?.driver_signature ? (
                    <img
                      src={
                        props?.item?.collection &&
                        props?.item?.collection?.driver_signature
                      }
                      height="60px"
                      width="60px"
                      style={{
                        display: "block",
                      }}
                    />
                  ) : null}
                </div>
              </td>
            </tr>
          </table>
        </div>

        {/* {medianBoxNum >= 11 ? (
          <div style={{ padding: "20px" }}>
            <br />
            <div className="print-invoice-table-row">
              <div className="print-invoice-table-column">
                <table className="print-invoice-table">
                  <tr>
                    <th className="print-customs-td" colSpan={1}>
                      <div className="print-customsInvoice-txt5"> Sl No</div>
                    </th>
                    <th className="print-customs-td" colSpan={2}>
                      <div className="print-customsInvoice-txt5">
                        Description
                      </div>
                    </th>
                    <th className="print-customs-td" colSpan={1}>
                      <div className="print-customsInvoice-txt5">Qty</div>
                    </th>
                    <th className="print-customs-td" colSpan={1}>
                      <div className="print-customsInvoice-txt5">Value</div>
                    </th>
                  </tr>
                  {boxItems &&
                    boxItems.slice(15, 30).map((items, index) => {
                      return (
                        <tr key={index}>
                          <td className="print-invoice-table-td" colSpan={1}>
                            <div className="print-customsInvoice-txt6">
                              {index + 16}
                            </div>
                          </td>
                          <td className="print-invoice-table-td" colSpan={2}>
                            <div className="print-customsInvoice-txt6">
                              {items.item}
                            </div>
                          </td>
                          <td className="print-invoice-table-td" colSpan={1}>
                            <div className="print-customsInvoice-txt6">
                              {items.quantity}
                            </div>
                          </td>
                          <td className="print-invoice-table-td" colSpan={1}>
                            <div className="print-customsInvoice-txt6">
                              {(Number(items.value) * USD).toFixed(2)}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </table>
              </div>
              <div className="print-invoice-table-column">
                <table className="print-invoice-table">
                  <tr>
                    <th className="print-customs-td" colSpan={1}>
                      <div className="print-customsInvoice-txt5"> Sl No</div>
                    </th>
                    <th className="print-customs-td" colSpan={2}>
                      <div className="print-customsInvoice-txt5">
                        Description
                      </div>
                    </th>
                    <th className="print-customs-td" colSpan={1}>
                      <div className="print-customsInvoice-txt5">Qty</div>
                    </th>
                    <th className="print-customs-td" colSpan={1}>
                      <div className="print-customsInvoice-txt5">Value</div>
                    </th>
                  </tr>
                  {boxItems &&
                    boxItems.slice(30, 40).map((items, index) => {
                      return (
                        <tr key={index}>
                          <td className="print-invoice-table-td" colSpan={1}>
                            <div className="print-customsInvoice-txt6">
                              {index + 31}
                            </div>
                          </td>
                          <td className="print-invoice-table-td" colSpan={2}>
                            <div className="print-customsInvoice-txt6">
                              {items.item}
                            </div>
                          </td>
                          <td className="print-invoice-table-td" colSpan={1}>
                            <div className="print-customsInvoice-txt6">
                              {items.quantity}
                            </div>
                          </td>
                          <td className="print-invoice-table-td" colSpan={1}>
                            <div className="print-customsInvoice-txt6">
                              {(Number(items.value) * USD).toFixed(2)}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </table>
              </div>
            </div>
            <br />
          </div>
        ) : null} */}
      </div>

      <Row>
        <Col sm="6"></Col>
        <Col sm="3">
          <Button onClick={() => props.onClose()} block size="large">
            Cancel
          </Button>
        </Col>
        <Col sm="3">
          <ReactToPrint
            trigger={() => (
              <Button
                type="primary"
                size="large"
                block
                onClickCapture={() => {
                  isPrinted();
                }}
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Col>
      </Row>
    </Modal>
  );
}
export default PrintCustomesModal;
